"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$NotificationBodyResponseDto = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
exports.$NotificationBodyResponseDto = {
    properties: {
        title: {
            type: 'string',
            description: `The title of the notification, which is the text that will be displayed in the notification.`,
            isRequired: true,
        },
        body: {
            type: 'string',
            description: `The body of the notification, which is the text that will be displayed in the notification.`,
        },
        imageUrl: {
            type: 'string',
            description: `The URL of the image to display in the notification, generally used space.avatar.`,
        },
        data: {
            type: 'all-of',
            description: `The data to be sent with the notification, generally used to fill in the notification template.`,
            contains: [{
                    type: 'DataTypeResponseDto',
                }],
        },
        email_options: {
            type: 'all-of',
            description: `The email options if you want send an email with the notification.`,
            contains: [{
                    type: 'EmailOptionsResponseDto',
                }],
        },
    },
};
